import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";

// import JS files
import RemoveModal from "../../../shares/RemoveModal";
// import MuiDatePicker from "../../../shares/MuiDatePicker";
import CreateOrderCard from "../../../shares/CreateOrderCard";
import EditRingModal from "../../../admin-panels/quick-access/EditRingModal";
import RingNumbersEdit from "../../../shares/RingNumbersEdit";

const ReturnedBasketOrderCard = (props) => {
  const [openRemoveModal, setOpenRemoveModal] = useState(false);


  const update_nums = (numIndex, nValue) => {
    props.updateRingNumUsingIndex(props.ringIndex, numIndex, nValue);
  };

  const [dateValue, setDateValue] = useState(props.item.date);

  function dateOnChange(date) {
    props.updateRingDateUsingIndex(props.ringIndex, date);
    setDateValue(date);
  }
  const get_total_weight = () => {
    let total = 0;
    props.item.nums.map((number, index) => {
      if (index == 0) {
        if (number !== "") {
          total +=
            parseInt(number) * parseFloat(props.item.ring.size_one_weight);
        }
      }
      if (index == 1) {
        if (number !== "") {
          total +=
            parseInt(number) * parseFloat(props.item.ring.size_two_weight);
        }
      }
      if (index == 2) {
        if (number !== "") {
          total +=
            parseInt(number) * parseFloat(props.item.ring.size_three_weight);
        }
      }
      if (index == 3) {
        if (number !== "") {
          total +=
            parseInt(number) * parseFloat(props.item.ring.size_four_weight);
        }
      }
      if (index == 4) {
        if (number !== "") {
          total +=
            parseInt(number) * parseFloat(props.item.ring.size_five_weight);
        }
      }
      if (index == 5) {
        if (number !== "") {
          total +=
            parseInt(number) * parseFloat(props.item.ring.size_six_weight);
        }
      }
    });
    return total.toFixed(3);
  };
  const [selectedOrderItem, setSelectedOrderItem] = useState();
  const [openEditRingModal, setOpenEditRingModal] = useState(false);
  const handleEditRingModal = (order_item_id) => {
    setSelectedOrderItem(order_item_id);
    setOpenEditRingModal((before) => !before);
  };
  const handleOrderItemEditRing = (order_item_id , selected_ring) =>{
    props.handleEditRing(order_item_id, selected_ring);
    setOpenEditRingModal(false);

  }
  return (
    <>
      {openRemoveModal && (
        <RemoveModal
          openModal={openRemoveModal}
          setOpenModal={setOpenRemoveModal}
          text="آیا از حذف محصول موردنظر از لیست سفارش خود اطمینان دارید؟"
        />
      )}
      {openEditRingModal && (
        <EditRingModal
          openModal={openEditRingModal}
          setOpenModal={setOpenEditRingModal}
          // getOrderApi={getOrderApi}
          handleEdit={handleOrderItemEditRing}
          orderId={selectedOrderItem}
          fromContext
        />
      )}
      <div className="border rounded-lg p-2 mt-2">
        <CreateOrderCard ring={props.item.ring}>
          <div className="md:grid grid-cols-12 gap-x-2 items-center">
            <div className="md:col-span-1 text-center ">
              <span className="text-sm">{get_total_weight()} گرم</span>
            </div>
            <div className="md:col-span-8 ">
              <RingNumbersEdit
                dynamicMap={true}
                nums={props.item.nums}
                update_nums={update_nums}
                item={props.item.ring}
                notShowTitle
                autoFocusFalse
              />
            </div>
            <div className="md:col-span-3 grid grid-cols-2 md:grid-cols-3 ">
              {/* <div className="md:col-span-2 mr-2 md:mr-0 mt-2 md:-mt-1">
                <MuiDatePicker onChange={dateOnChange} value={dateValue} />
              </div> */}
              <div className="md:col-span-1 text-left md:text-center mt-4 md:mt-1">
                <div
                  className="delete-icon "
                  onClick={() => props.removeRing(props.ringIndex)}
                >
                  <DeleteIcon />
                </div>
                {/* <div
                  className="edit-icon "
                  onClick={() => handleEditRingModal(props.item.history_id)}
                >
                  <ModeEditIcon />
                </div> */}
              </div>
            </div>
          </div>
        </CreateOrderCard>
      </div>
    </>
  );
};

export default ReturnedBasketOrderCard;
